import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { SelectField } from "../../ui";

interface SelectAgenciaEmpresaProps {
  name: string;
  methods: any;
  idBank?: string;
  disabled?: boolean;
  required?: boolean;
  label?: string;
}

export function SelectAgenciaEmpresa({
  name,
  methods,
  idBank,
  disabled = false,
  required = false,
  label = "Selecione uma Agência",
}: SelectAgenciaEmpresaProps) {
  const [agencias, setAgencias] = useState<any[]>([]);

  useEffect(() => {
    if (!idBank) {
      setAgencias([]);
      return;
    }
    const fetchData = async () => {
      const data = await baseApiService.get(
        `bank-registration/select/agency/${idBank}`
      );
      setAgencias(data.data.data);
    };
    fetchData();
  }, [idBank]);

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <SelectField
          label={label}
          value={field.value || ""}
          onChange={(e) => field.onChange(e.target.value)}
          required={required}
          disabled={disabled || !idBank}
        >
          <option value="" />
          {agencias.map((agencia) => (
            <option key={agencia.id} value={agencia.id}>
              {`${agencia.agencyNumber}${
                agencia?.name ? " - " + agencia.name : ""
              }`}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}
